import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Droplets, Flame, Hammer, Building2 } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { SERVICE_META } from "../lib/data";

const ICONS = { Droplets, Flame, Hammer, Building2 };

export const ServiceCard = ({ slug, index = 0, variant = "default" }) => {
  const { t } = useLang();
  const meta = SERVICE_META[slug];
  const service = t.services[slug];
  const Icon = ICONS[meta.icon];

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className="card-3d group relative overflow-hidden rounded-3xl border border-slate-200 bg-white"
      data-testid={`service-card-${slug}`}
    >
      <Link to={`/dienstleistungen/${slug}`} className="block">
        <div className="relative h-56 overflow-hidden">
          <img
            src={meta.image}
            alt={service.name}
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0022FF]/80 via-[#0022FF]/20 to-transparent" />
          <div
            className="absolute top-4 left-4 inline-flex items-center justify-center h-12 w-12 rounded-2xl backdrop-blur-md bg-white/90 shadow-lg"
            style={{ color: meta.color }}
          >
            <Icon className="h-6 w-6" strokeWidth={2.2} />
          </div>
          <div className="absolute bottom-4 left-4 right-4">
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/80 font-semibold mb-1">
              0{index + 1}
            </div>
            <h3 className="font-display font-black text-white text-2xl tracking-tight">
              {service.name}
            </h3>
          </div>
        </div>
        <div className="p-6 space-y-4">
          <p className="text-sm text-slate-600 leading-relaxed min-h-[3rem]">
            {service.long.slice(0, 130)}…
          </p>
          <div className="flex items-center justify-between pt-2">
            <span className="text-sm font-semibold text-[#0022FF] group-hover:underline">
              {t.home.servicesLearnMore}
            </span>
            <div className="h-9 w-9 rounded-full bg-[#0022FF] text-white flex items-center justify-center transition-transform group-hover:rotate-45">
              <ArrowUpRight className="h-4 w-4" />
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
